// UTM capture & persistence (first-touch attribution)
import { devWarn } from "./logger";

const KEY = "_m2s_utm_v1";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];

export function captureUTM() {
  if (typeof window === "undefined") return {};
  try {
    const url = new URL(window.location.href);
    const captured = {};
    let hasNew = false;
    PARAMS.forEach((p) => {
      const v = url.searchParams.get(p);
      if (v) {
        captured[p] = v;
        hasNew = true;
      }
    });
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    if (hasNew) {
      const merged = { ...captured, _ts: Math.floor(Date.now() / 1000) };
      localStorage.setItem(KEY, JSON.stringify(merged));
      return merged;
    }
    return existing || {};
  } catch (e) {
    devWarn("[utm] capture failed", e);
    return {};
  }
}

export function getUTM() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch (e) {
    devWarn("[utm] read failed", e);
    return {};
  }
}
